/**
 * @file AgentEmails.jsx
 * @description AgentEmails component for displaying and managing agent emails.
 * @component AgentEmails
 * @exports AgentEmails - Main component for displaying and managing agent emails.
 */

import React, { useState, useEffect } from "react";
import LinearProgress from '@mui/material/LinearProgress';
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Box
} from "@mui/material";
import { SIZES } from "../../../common/constants/commonConstants.js";
import { EMAILS_TABLE_COLUMNS } from "../../../common/constants/agentModule/statusConstants.js";
import { getAgentEmails } from "../../../services/agentModule/agentInfoServices.js";

const AgentEmails = () => {
	const [emails, setEmails] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const agentGUID = localStorage.getItem("userguid");

	useEffect(() => {
		fetchEmails();
	}, []);

	const fetchEmails = async () => {
		setIsLoading(true);
		try {
			const data = await getAgentEmails({ agentGUID });
			setEmails(data || []);
		} catch (error) {
			console.error("Error fetching texts:", error);
		} finally {
			setIsLoading(false);
		}
	};

	const formatDate = (isoDate) => {
		const date = new Date(isoDate);
		return date.toLocaleString();
	};

	return (
		<>
			{isLoading ? (
				<>
					<Box sx={{ width: '100%' }}>
						<LinearProgress />
					</Box>
				</>
			) : (
				<>
					<TableContainer>
						<Table size={SIZES.SMALL}>
							<TableHead>
								<TableRow>
									{EMAILS_TABLE_COLUMNS.map((column) => (
										<TableCell
											key={column.id}
											sx={{
												width:
													column.id === EMAILS_TABLE_COLUMNS.FIRSTNAME ? 150 :
													column.id === EMAILS_TABLE_COLUMNS.LASTNAME ? 150 :
													column.id === EMAILS_TABLE_COLUMNS.CUSTOMER ? 150 :
													column.id === EMAILS_TABLE_COLUMNS.RESPONSE ? 200 :
													column.id === EMAILS_TABLE_COLUMNS.DATE ? 100 :
													column.id === EMAILS_TABLE_COLUMNS.RESPONSEDATE ? 100 : 150,
											}}
										>
											{column.label}
										</TableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{emails.length === 0 ? (
									<TableRow>
										<TableCell colSpan={6} align="center">
											No Emails Found
										</TableCell>
									</TableRow>
								) : (
									emails.map((emails, index) => (
										<TableRow key={index}>
											<TableCell>{emails.lastname}</TableCell>
											<TableCell>{emails.firstname}</TableCell>
											<TableCell>{emails.userresponse}</TableCell>
											<TableCell>{emails.cararesponse}</TableCell>
											<TableCell>{formatDate(emails.userresponsetime)}</TableCell>
											<TableCell>{formatDate(emails.cararesponsetime)}</TableCell>
										</TableRow>
									))
								)}
							</TableBody>
						</Table>
					</TableContainer>
				</>
			)}
		</>
	);
};

export default AgentEmails;